import InspectionEvent from "../../../models/inspection/inspection-event.entity";
import http from "../../../services/http.service";
import storageService from "../../../services/storage.service";
import tokenRefreshService from "../../../services/token-refresh.service";
import { rejectApiError } from "../../../services/api-error.service";

class InspectionEventService {
  sendInspectionEvent = async (event: InspectionEvent) => http
    .post('/inspection-event-fleet-offline', event.createPayload())
    .catch(rejectApiError);

  showById = async (inspectionId: string) => http
    .get(`/inspection/${inspectionId}/fleet`)
    .catch(rejectApiError);

  getConfirmation = async (inspectionId: string) => http
    .get(`/inspection/${inspectionId}/fleet/confirm`)
    .catch(rejectApiError);

  sendFormData = (
    url: string,
    bodyFormData: any,
    percentageCallback: any,
  ) => new Promise((resolve, reject) => {
    const host = process.env.REACT_APP_API_URL;
    let refreshed = false;

    const attempt = (token: string) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${host}${url}`);
      xhr.timeout = 120000;
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');

      xhr.upload.addEventListener('progress', (e) => {
        const percent = e.lengthComputable ? (e.loaded / e.total) * 100 : 0;
        percentageCallback(percent.toFixed(0));
      });

      xhr.onload = () => {
        const { status } = xhr;

        if (status === 200 || status === 201) {
          resolve(xhr.response);
          return;
        }

        if (status === 401 && !refreshed) {
          refreshed = true;
          tokenRefreshService.refresh()
            .then((newToken) => attempt(newToken))
            .catch(() => reject({ status, response: xhr.response }));
          return;
        }

        reject({ status, response: xhr.response, retryAfter: xhr.getResponseHeader('Retry-After') });
      };

      xhr.onerror = () => {
        reject({ status: 0, response: '{}' });
      };

      xhr.ontimeout = () => {
        reject({ status: 0, response: '{}' });
      };

      xhr.send(bodyFormData);
    };

    const session = storageService.getObject('session') || {};
    attempt(session.access_token || '');
  });

  getFileByDataURL = async (dataUrl: string, fileName: string): Promise<File> => {
    const res: Response = await fetch(dataUrl);
    const blob: Blob = await res.blob();
    return new File([blob], `${fileName}.jpeg`, { type: 'image/jpeg' });
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new InspectionEventService();
